import { getAllEntitiesColumns } from "../../../environment/entitiesTable/allEntitiesColumns";
import { getSharedColumns } from "../../../environment/entitiesTable/sharedColumns";

export default function getEntitiesInAssetTableColumns(
  assets,
  colors,
  showLocalTime
) {
  const columns = [...getSharedColumns(assets)];

  const extraColumns = getAllEntitiesColumns(colors, showLocalTime);
  columns.unshift(extraColumns.entityType);
  columns.push(extraColumns.last_seen);

  return columns;
}
